import type { AdTagType, EventType } from '../../../../../../configs';
import { adTagEvents, adTagTypes, getPermittedAdTagEvents } from '../../../../../../configs';

export const getDefaultPositionForType = (
  newType: AdTagType,
  currentPosition?: EventType,
  lineItemBillableEvent?: string | null
): EventType => {
  if (newType === adTagTypes.CLICK.key) return adTagEvents.CLICK.key;

  const permitted = getPermittedAdTagEvents(newType, lineItemBillableEvent ?? undefined);
  const permittedKeys = permitted.map((p) => p.key);

  if (currentPosition && permittedKeys.includes(currentPosition)) {
    return currentPosition;
  }

  return permitted[0]?.key ?? adTagEvents.COMPLETE.key;
};
